import { cn } from '@lyearn/style';

import { MenuButtonClasses, ReactionSelectorProps } from './types';

export const DEFAULTS: ReactionSelectorProps['overrides'] = {
  MenuButton: {
    classes: {
      open: 'text-icon-active',
      closed: 'text-icon-secondary hover:text-icon-primary',
      root: 'flex-shrink-0 hover:bg-s-info-light rounded-4 p-2 flex justify-center items-center',
    },
  },
  Icon: {
    className: 'w-20 h-20',
  },
};

export const getMenuButtonClassName = (open: boolean, classes?: MenuButtonClasses) =>
  cn(classes?.root, open ? classes?.open : classes?.closed);
